import PropTypes from 'prop-types';
import { useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export default function GuestGuard ({ children }) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container> {children}</Container>}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------

function Container ({ children }) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.dashboard.root;

  const { isAuthenticated } = useAuthContext();

  // If plan/billing params are present, the register/login view will handle
  // the Stripe checkout redirect after auth — don't navigate away.
  const hasPendingCheckout = searchParams.get('plan') && searchParams.get('billing');

  const check = useCallback(() => {
    if (isAuthenticated && !hasPendingCheckout) {
      router.replace(returnTo);
    }
  }, [isAuthenticated, hasPendingCheckout, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}

Container.propTypes = {
  children: PropTypes.node,
};
